// pp-calc-mudanza.js — ¿Cuántas Cajas Necesito para mi Mudanza?
// (/pages/cuantas-cajas-necesito-para-mudanza)
//
// Estimación práctica de Para Paquetes, por ambiente (chicas + medianas +
// grandes):
//
//   por recámara        8 + 6 + 2
//   sala / comedor      4 + 6 + 4
//   cocina              6 + 4 + 0   (y burbuja extra para la vajilla)
//   por baño            2 + 1 + 0
//   por persona >2     +3 + 2 + 1
//
// Todo se multiplica por el factor de "qué tanto tienes" (vivo ligero 0.8 /
// normal 1 / tengo muchas cosas 1.3) y se redondea hacia ARRIBA — mejor que
// te sobren 3 cajas a que te falten a las 10 pm del día de la mudanza.
//
// Consumibles: cinta = 1 rollo por cada 12 cajas (redondeo arriba, mínimo 2);
// burbuja = 10 m si hay cocina + 5 m por recámara; marcador = 1 por persona.
// Aritmética pura probada en tests/calc-mudanza.test.mjs.
(function (root) {
  'use strict';

  // [chicas, medianas, grandes]
  var POR_RECAMARA = [8, 6, 2];
  var SALA_COMEDOR = [4, 6, 4];
  var COCINA = [6, 4, 0];
  var POR_BANO = [2, 1, 0];
  var POR_PERSONA_EXTRA = [3, 2, 1]; // por persona adicional a 2

  var CAJAS_POR_ROLLO_CINTA = 12;
  var MIN_ROLLOS_CINTA = 2;
  var BURBUJA_COCINA_M = 10;
  var BURBUJA_POR_RECAMARA_M = 5;

  // Entradas: recamaras, banos, personas (números ≥ 0), sala y cocina
  // (booleanos), factor (0.8 | 1 | 1.3).
  function calcularMudanza(e) {
    if (!e) return null;
    var rec = num(e.recamaras), ban = num(e.banos), per = num(e.personas), factor = num(e.factor);
    if ([rec, ban, per].some(function (v) { return v === null || v < 0; })) return null;
    if (factor === null || factor <= 0) return null;
    var sala = !!e.sala, cocina = !!e.cocina;
    var extras = Math.max(0, per - 2);

    var base = [0, 1, 2].map(function (i) {
      return rec * POR_RECAMARA[i] +
        (sala ? SALA_COMEDOR[i] : 0) +
        (cocina ? COCINA[i] : 0) +
        ban * POR_BANO[i] +
        extras * POR_PERSONA_EXTRA[i];
    });

    var chicas = Math.ceil(base[0] * factor);
    var medianas = Math.ceil(base[1] * factor);
    var grandes = Math.ceil(base[2] * factor);
    var totalCajas = chicas + medianas + grandes;

    return {
      chicas: chicas,
      medianas: medianas,
      grandes: grandes,
      totalCajas: totalCajas,
      cinta: Math.max(MIN_ROLLOS_CINTA, Math.ceil(totalCajas / CAJAS_POR_ROLLO_CINTA)),
      burbujaM: (cocina ? BURBUJA_COCINA_M : 0) + rec * BURBUJA_POR_RECAMARA_M,
      marcadores: Math.ceil(per),
      factor: factor
    };
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcMudanza = {
    calcularMudanza: calcularMudanza
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-mudanza]');
    if (!raiz) return;
    var C = window.PPCalcMudanza;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    function fmt(n) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: 0 });
    }

    function correr() {
      var f = new FormData(form);
      var r = C.calcularMudanza({
        recamaras: f.get('recamaras'),
        sala: f.get('sala') !== null,
        cocina: f.get('cocina') !== null,
        banos: f.get('banos'),
        personas: f.get('personas'),
        factor: f.get('factor')
      });
      pintar(r);
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: recámaras, baños y personas no pueden ir vacíos ni en negativo.</p>';
        return;
      }
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
      html += '<p class="pp-calc__veredicto-titulo">Para tu mudanza necesitas ≈ ' + fmt(r.totalCajas) + ' cajas</p>';
      html += '<p class="pp-calc__veredicto-dato">' + fmt(r.chicas) + ' chicas para lo pesado, ' + fmt(r.medianas) + ' medianas para lo diario y ' + fmt(r.grandes) + ' grandes para lo ligero y voluminoso — más cinta, burbuja y marcadores.</p>';
      html += '</div>';
      html += '<dl class="pp-calc__detalle">';
      html += '<div class="pp-calc__detalle-fila"><dt>Cajas chicas</dt><dd>' + fmt(r.chicas) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Cajas medianas</dt><dd>' + fmt(r.medianas) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Cajas grandes</dt><dd>' + fmt(r.grandes) + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Cinta canela</dt><dd>' + fmt(r.cinta) + ' ' + (r.cinta === 1 ? 'rollo' : 'rollos') + '</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Rollo de burbuja</dt><dd>' + fmt(r.burbujaM) + ' m</dd></div>';
      html += '<div class="pp-calc__detalle-fila"><dt>Marcadores</dt><dd>' + fmt(r.marcadores) + '</dd></div>';
      html += '</dl>';
      html += '<p class="pp-calc__nota">Estimación práctica de Para Paquetes — mejor que te sobren 3 cajas a que te falten a las 10 pm del día de la mudanza. Si hay vajilla o cristal, súmale burbuja.</p>';
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr();
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
